
import { useState, useEffect} from "react";

import input_check from "../input_check.png";
import input_error from "../input_error.png";


function InputChecbox(props)
{

    
    
    
    
    const [val, setVal] = useState(props.value);
    const [req, setRequired] = useState(props.req);   
    const [cn, setClassName] = useState('');

 

    var cs = props.checked;
    if(cs == '1')  {  cs = true; } else 
    if(cs == '0')  {  cs = false; } else 
    if(cs == ' ')  {  cs = false; } ; 

    const [checked, setChecked] = useState(cs);

    const [onShow,setOnShow] = useState(false);


   

    const checkAndChange = (e) =>
    {
        
        var ch = false;
        
        if(checked == false) ch = true;
        setChecked(!checked);
   
        
 
        var correct = true;

        if(req == "1" && !ch )  correct = false;
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
             props.valChange(props.name, val, ch,'');
        }else
        {
            console.log('No support for valChange');
        }    
    }

   

 

    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' && checked == false ) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }


    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }



    useEffect(() => {

        if(val != props.value) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, checked,'');
    
        }
    })



    var exp = props.name.split('@');
    var nameF = exp[0];

 

    var err = "";    
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[nameF] != null  && props.err[nameF] != undefined    ) err = props.err[nameF]['param'];
    }



    var cnX = cn;
    if( val != null &&  val.length < 1 && cnX == 'corrent')
        {
            cnX = '';
        }


    if(props.checked != checked)     setChecked(props.checked);

    return <fieldset>
            <input type="checkbox" checked={checked}  value={val} onChange={checkAndChange}  name={props.name} placeholder={props.placeholder} className={props.className + "   " + cnX} />        
            {props.title}
             {imgx}
             <br/>
             <span className="form_err">{err + " "} &nbsp; </span>
           </fieldset>
}


export default InputChecbox;